import { Form, Input, Space, Typography } from 'antd'
import { useAnswer } from '../../contexts/AnswerContext'
import { useFormEditor } from '../../contexts/FormContext'

const { TextArea } = Input
const { Text } = Typography

interface Props {}

export const ManagerComment = ({}: Props) => {
  const { item } = useAnswer()
  const { isFulfilled } = useFormEditor()

  if (item === undefined || !item.isCommentableByManager) return <></>

  return (
    <Space size={5} vertical className="w-full">
      <Text strong>Votre commentaire :</Text>
      <Form.Item key={item.id} name={[item.id, 'managerComment']}>
        <TextArea rows={4} disabled={isFulfilled} />
      </Form.Item>
    </Space>
  )
}

export type ManagerCommentType = { ManagerComment: typeof ManagerComment }
